/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { toAbsoluteUrl, checkIsActive } from '../../../helpers'
import { useIntl } from 'react-intl'
import { getSelectedLocation } from '../../../../utils'

interface ISubItems {
  to: string
  icon: string
  title: string
  expired?: boolean
}

interface IMenuItems {
  to: string
  title: string
  icon: string
  expired?: boolean
  subItems?: ISubItems[]
}

export function AsideMenuMain() {
  // Dil
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({ id }, values)

  const { pathname } = useLocation()
  const [isExpired, setIsExpired] = useState(false)
  const [isRuijie, setIsRuijie] = useState(false)
  useEffect(() => {
    const x = async () => {
      const selectedLocation = getSelectedLocation()


      if (!selectedLocation) {
        setIsExpired(true)
        return
      }


      // ✅ DÜZELTME: String ve number ikisini de kontrol et
      const isActiveCheck = selectedLocation.is_active === "1" || selectedLocation.is_active === 1

      const shouldDisable =
        new Date(selectedLocation.expire) < new Date() ||
        !isActiveCheck


      setIsExpired(shouldDisable)
      setIsRuijie(String(selectedLocation.type) === '2')
    }
    x()
  }, [])
  const menuItems: IMenuItems[] = [
    // Home
    {
      to: '/home',
      title: t('summary_panel'),
      icon: '/media/icons/bootstrap/aside/pie-chart-fill.svg',
    },
    // Locations
    {
      to: '/locations',
      title: t('my_locations'),
      icon: '/media/icons/bootstrap/aside/geo-alt-fill.svg',
    },
    // LOCATION SETTINGS::start
    {
      to: '#',
      title: t('location_settings'),
      expired: isExpired,
      icon: '/media/icons/bootstrap/aside/gear-fill.svg',
      subItems: [
        {
          to: '/view-settings',
          icon: '/media/icons/bootstrap/aside/sliders.svg',
          title: t('view_settings'),
        },
        {
          to: '/survey',
          icon: '/media/icons/bootstrap/aside/newspaper.svg',
          title: t('survey_transactions'),
        },
        {

          to: '/campaign',
          icon: '/media/icons/bootstrap/aside/megaphone-fill.svg',
          title: t('campaign_transactions'),
        },
        {
          to: '/promotion',
          icon: '/media/icons/bootstrap/aside/gift-fill.svg',
          title: t('promotion_transactions'),
        },
        {
          to: '/nas-limit/0',
          icon: '/media/icons/bootstrap/aside/wifi.svg',
          title: t('default_limitations'),
        },
      ],

    },
    // LOCATION SETTINGS::end
    // USER TRANSACTIONS::start
    {
      to: '#',
      title: t('user_transactions'),
      expired: isExpired,
      icon: '/media/icons/bootstrap/aside/people-fill.svg',
      subItems: [
        ...(isRuijie
          ? []
          : [
            {
              to: '/nas-hotspot-active-list',
              icon: '/media/icons/bootstrap/aside/router-fill.svg',
              title: t('hotspot_users_live'),
            },
            {
              to: '/nas-pppoe-active-list',
              icon: '/media/icons/bootstrap/aside/ethernet.svg',
              title: t('pppoe_users_live'),
            },
          ]),
        {
          to: '/nas-user-registered',
          icon: '/media/icons/bootstrap/aside/send-exclamation-fill.svg',
          title: t('pending_approval'),
        },
        {
          to: '/nas-user-group',
          icon: '/media/icons/bootstrap/aside/people-fill.svg',
          title: t('user_groups'),
        },
        {
          to: '/nas-users',
          icon: '/media/icons/bootstrap/aside/person-fill-check.svg',
          title: t('registered_users'),
        },
        {
          to: '/nas-user-auto',
          icon: '/media/icons/bootstrap/aside/share-fill.svg',
          title: t('integration_users'),
        },
        {
          to: '/nas-user-sms',
          icon: '/media/icons/bootstrap/aside/envelope-fill.svg',
          title: t('sms_users'),
        },
        ...(isRuijie
          ? []
          : [
            {
              to: '/vpn-user',
              icon: '/media/icons/bootstrap/aside/shield-fill-check.svg',
              title: t('vpn_users'),
            },
          ]),
        {
          to: '/coupon',
          icon: '/media/icons/bootstrap/aside/ticket-perforated-fill.svg',
          title: t('voucher'),
        },
      ],
    },
    // USER TRANSACTIONS::end
    // SMS TRANSACTIONS::start
    {
      to: '#',
      title: t('sms_transactions'),
      icon: '/media/icons/bootstrap/aside/chat-dots-fill.svg',
      subItems: [
        {
          to: '/sms-send',
          icon: '/media/icons/bootstrap/aside/envelope-arrow-up-fill.svg',
          title: t('bulk_sms'),
          expired: isExpired,
        },

        {
          to: '/sms-balance',
          icon: '/media/icons/bootstrap/aside/wallet2.svg',
          title: t('balance'),
          expired: isExpired,
        },
        {
          to: 'sms-settings',
          icon: '/media/icons/bootstrap/aside/envelope-fill.svg',
          title: t('sms_settings_t'),
          expired: isExpired

        },
      ],
    },
    // SMS TRANSACTIONS::end
    // NETWORK SETTINGS::start
    ...(isRuijie
      ? []
      : [
        {
          to: '#',
          title: t('network_settings'),
          expired: isExpired,
          icon: '/media/icons/bootstrap/aside/globe.svg',
          subItems: [
            {
              to: '/vpn-settings',
              icon: '/media/icons/bootstrap/aside/shield-fill-check.svg',
              title: t('vpn'),
            },
            {
              to: '/ipsec-vpn',
              icon: '/media/icons/bootstrap/aside/shield-fill-check.svg',
              title: t('ipsec_vpn'),
            },
            {
              to: '/port-forwarding',
              icon: '/media/icons/bootstrap/aside/arrow-left-right.svg',
              title: t('port_forwarding'),
            },
            {
              to: '/static-ip',
              icon: '/media/icons/bootstrap/aside/arrow-left-right.svg',
              title: t('ip_fix'),
            },
            {
              to: '/ip-list',
              icon: '/media/icons/bootstrap/aside/newspaper.svg',
              title: t('ip_list'),
            },
            {
              to: '/dhcp-lease',
              icon: '/media/icons/bootstrap/aside/list-task.svg',
              title: t('dhcp_lease'),
            },
          ],
        },
      ]),
    // NETWORK SETTINGS::end
    // SECURITY SETTINGS::start
    ...(isRuijie
      ? []
      : [
        {
          to: '#',
          title: t('security_settings'),
          expired: isExpired,
          icon: '/media/icons/bootstrap/aside/shield-shaded.svg',
          subItems: [
            {
              to: '/privilege-action',
              icon: '/media/icons/bootstrap/aside/shield-fill-check.svg',
              title: t('privilege_transaction'),
            },
            {
              to: '/forbidden-mac',
              icon: '/media/icons/bootstrap/aside/ban.svg',
              title: t('forbidden_mac'),
            },
            {
              to: '/filter',
              icon: '/media/icons/bootstrap/aside/funnel-fill.svg',
              title: t('content_filtering'),
            },
          ],
        },
      ]),
    // SECURITY SETTINGS::end
    // LOCATION LOGS::start
    {
      to: '#',
      title: t('location_logs'),
      icon: '/media/icons/bootstrap/aside/bar-chart-line-fill.svg',
      subItems: [
        {
          to: '/dhcp-logs',
          expired: isExpired,
          icon: '/media/icons/bootstrap/aside/list-task.svg',
          title: t('dhcp_logs'),
        },
        {
          to: '/port-logs',
          expired: isExpired,
          icon: '/media/icons/bootstrap/aside/link-45deg.svg',
          title: t('port_logs'),
        },
        {
          to: '/5651-logs',
          icon: '/media/icons/bootstrap/aside/record-circle.svg',
          title: t('5651_logs'),
        },
        {
          to: '/sms-logs',
          icon: '/media/icons/bootstrap/aside/chat-dots-fill.svg',
          title: t('sms_logs'),
        },
      ],
    },
    // LOCATION LOGS::end
    // LOCATION REPORTS::start
    {
      to: '#',
      title: t('location_reports'),
      expired: isExpired,
      icon: '/media/icons/bootstrap/aside/newspaper.svg',
      subItems: [
        {
          to: '/hourly-reports',
          icon: '/media/icons/bootstrap/aside/clock-fill.svg',
          title: t('hourly_report_detail'),
        },
        {
          to: '/daily-reports',
          icon: '/media/icons/bootstrap/aside/person-fill.svg',
          title: t('daily_report_detail'),
        },
        {
          to: '/weekly-reports',
          icon: '/media/icons/bootstrap/aside/people-fill.svg',
          title: t('weekly_report_detail'),
        },
        {
          to: '/monthly-reports',
          icon: '/media/icons/bootstrap/aside/calendar-check-fill.svg',
          title: t('monthly_report_detail'),
        },
      ],
    },
    // LOCATION REPORTS::end
    // STATISTICS::start
    {
      to: '#',
      title: t('stats'),
      icon: '/media/icons/bootstrap/aside/graph-up.svg',
      subItems: [
        {
          to: '/location-statistics',
          icon: '/media/icons/bootstrap/aside/geo-alt-fill.svg',
          title: t('loc_stats'),
        },
        {
          to: '/device-statistics',
          icon: '/media/icons/bootstrap/aside/phone.svg',
          title: t('dev_stats'),
        },
        {
          to: '/user-statistics',
          icon: '/media/icons/bootstrap/aside/person-fill.svg',
          title: t('user_stats'),
        },
      ],
    },
    // STATISTICS::end
    // MULTI CONFIGURATION::start
    {
      to: '#',
      title: t('multi_conf'),
      expired: isExpired,
      icon: '/media/icons/bootstrap/aside/gear-fill.svg',
      subItems: [
        {
          to: '/multi-configuration',
          icon: '/media/icons/bootstrap/aside/geo-alt-fill.svg',
          title: t('loc_conf'),
        },
      ],
    },
    // MULTI CONFIGURATION::end
    // API INTEGRATION::start
    {
      to: '#',
      title: t('api_integration'),
      expired: isExpired,
      icon: '/media/icons/bootstrap/aside/link-45deg.svg',
      subItems: [
        {
          to: '/hotel-integration',
          icon: '/media/icons/bootstrap/aside/house-door-fill.svg',
          title: t('hotel_int'),
        },
        {
          to: '/statistic-integration',
          icon: '/media/icons/bootstrap/aside/graph-up.svg',
          title: t('statistic_integration'),
        },
        {
          to: '/coupon-integration',
          icon: '/media/icons/bootstrap/aside/ticket-perforated-fill.svg',
          title: t('voucher_integration'),
        },
        {
          to: '/device-integration',
          icon: '/media/icons/bootstrap/aside/phone.svg',
          title: t('device_status_integration'),
        },
      ],
    },
    // API INTEGRATION::end
    // SUPPORT::start
    {
      to: '#',
      title: t('support'),
      icon: '/media/icons/bootstrap/aside/telephone-inbound-fill.svg',
      subItems: [
        {
          to: '/live-support',
          icon: '/media/icons/bootstrap/aside/telephone-inbound-fill.svg',
          title: t('live_support'),
        },
        {
          to: '/support',
          icon: '/media/icons/bootstrap/buttons/chat-left-text-fill.svg',
          title: t('support'),
        },
      ],
    },
    // SUPPORT::end
  ]

  const getInitialOpenIndex = () => {
    const idx = menuItems.findIndex(item =>
      item.subItems?.some(sub => checkIsActive(pathname, sub.to))
    )
    return idx >= 0 ? idx : null
  }

  const [openIndex, setOpenIndex] = useState<number | null>(getInitialOpenIndex)

  useEffect(() => {
    const idx = menuItems.findIndex(item =>
      item.subItems?.some(sub => checkIsActive(pathname, sub.to))
    )
    if (idx >= 0) setOpenIndex(idx)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <>
      <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 ms-8 mb-6'>
        <div className='d-lg-none d-flex align-items-center'>
          <img alt='Logo' src={toAbsoluteUrl('/netway.png')} className='h-30px' />
          <h2 className='text-white mt-2 ms-4'>Wisnet</h2>
        </div>
      </div>
      {menuItems.map((item, index) =>
        item.subItems ? (
          <AsideMenuItemWithSub
            key={index}
            to={item.to}
            disabled={item.expired}
            title={item.title}
            fontIcon='bi-archive'
            icon={item.icon}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(prev => prev === index ? null : index)}
          >
            {item.subItems.map((item, index) => (
              <AsideMenuItem
                key={index}
                to={item.to}
                disabled={item.expired}
                icon={item.icon}
                title={item.title}
                iconSize='6'
              />
            ))}
          </AsideMenuItemWithSub>
        ) : (
          <AsideMenuItem
            key={index}
            to={item.to}
            disabled={item.expired}
            icon={item.icon}
            title={item.title}
            fontIcon='bi-layers'
          />
        )
      )}
    </>
  )
}